    export const testFall = (param, deviceId, mqttclient) => {
        const payload = {
            "type": 5,
            "payload": {
                "timestamp": Math.floor(Date.now() / 1000),
                "status": param,
                "care4u": true
            }
        }
        mqttclient.publish('/devices/' + deviceId + '/events', JSON.stringify(payload));
    }

    export const testSensitiveFall = (param, deviceId, mqttclient) => {
        const payload = {
            "type": 8,
            "payload": {
                "timestamp": Math.floor(Date.now() / 1000),
                "status": param,
                "care4u": true
            }
        }
        mqttclient.publish('/devices/' + deviceId + '/events', JSON.stringify(payload));
    }

    export const testPresence = (param, deviceId, mqttclient) => {
        const payload = {
            "type": 4,
            "payload": {
                "presenceDetected": param,
                "presenceTargetType": 0,
                "roomPresenceIndication": 0,
                "timestamp": Math.floor(Date.now() / 1000),
                "care4u": true
            }
        }
        mqttclient.publish('/devices/' + deviceId + '/events', JSON.stringify(payload));

    }

    export const testType12 = (deviceId, mqttclient) => {
        //test bed exit
        const payload = {
            "type": 12,
            "payload": {
                "timestamp": Math.floor(Date.now() / 1000),
                "care4u": true
            }
        }
        mqttclient.publish('/devices/' + deviceId + '/events', JSON.stringify(payload));
    }

    export const testType13 = (deviceId, mqttclient, doorId, direction) => {
        //test bed exit
        const payload = {
            "type": 13,
            "payload": {
                "recordTime": Math.floor(Date.now() / 1000),
                "doorEventType": direction,
                "doorId": doorId,
                "care4u": true
            }
        }
        mqttclient.publish('/devices/' + deviceId + '/events', JSON.stringify(payload));
    }

    export const testBed = (param, deviceId, mqttclient) => {
        //test bed exit
        const payload = {
            "type": 4,
            "payload": {
                "presenceTargetType": 0,
                "roomPresenceIndication": 0,
                "timestamp": Math.floor(Date.now() / 1000),
                "presenceRegionMap": {
                    0: param,
                },
                "care4u": true
            }
        }
        mqttclient.publish('/devices/' + deviceId + '/events', JSON.stringify(payload));
    }
